import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";
import type { DatabaseConfig } from '@/types/database';
import { getDatabaseTypeLabel, getDatabaseTypeBadgeColor } from '@/utils/databaseHelpers';

interface DatabaseConfigListProps {
  configs: DatabaseConfig[];
  onConfigSwitch: (config: DatabaseConfig) => void;
  onConfigDelete: (index: number) => void;
}

export function DatabaseConfigList({ 
  configs, 
  onConfigSwitch, 
  onConfigDelete 
}: DatabaseConfigListProps) {
  if (configs.length === 0) {
    return null;
  }

  const handleDeleteConfig = (index: number) => {
    onConfigDelete(index);
    toast.success("تم حذف الإعداد");
  };

  const handleSwitchConfig = (config: DatabaseConfig) => {
    onConfigSwitch(config);
    toast.success(`تم التبديل إلى: ${config.name}`);
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>الإعدادات المحفوظة</CardTitle>
        <CardDescription>
          قائمة بجميع إعدادات قواعد البيانات المحفوظة
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {configs.map((config, index) => (
            <div key={config.id} className="flex items-center justify-between p-3 border rounded-lg">
              <div className="space-y-1">
                <div className="flex items-center gap-2">
                  <span className="font-medium">{config.name}</span>
                  <Badge className={getDatabaseTypeBadgeColor(config.type)}>
                    {getDatabaseTypeLabel(config.type)}
                  </Badge>
                  {config.isActive && (
                    <Badge variant="default">نشط</Badge>
                  )}
                </div>
                <p className="text-sm text-muted-foreground">
                  {config.type === 'supabase' 
                    ? config.config.url 
                    : `${config.config.host}:${config.config.port}/${config.config.database}`
                  }
                </p>
              </div>
              
              <div className="flex gap-2">
                {!config.isActive && (
                  <Button
                    size="sm"
                    onClick={() => handleSwitchConfig(config)}
                  >
                    تفعيل
                  </Button>
                )}
                <Button
                  size="sm"
                  variant="destructive"
                  onClick={() => handleDeleteConfig(index)}
                >
                  حذف
                </Button>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}